/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Activity_TypeInputs */

const en_field_activity_type = /** @type {(inputs: Field_Activity_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity`)
};

const es_field_activity_type = /** @type {(inputs: Field_Activity_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actividad`)
};

const fr_field_activity_type = /** @type {(inputs: Field_Activity_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activité`)
};

const de_field_activity_type = /** @type {(inputs: Field_Activity_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivität`)
};

const ja_field_activity_type = /** @type {(inputs: Field_Activity_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティビティの種類`)
};

const zh_field_activity_type = /** @type {(inputs: Field_Activity_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动项目`)
};

const ar_field_activity_type = /** @type {(inputs: Field_Activity_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النشاط`)
};

const id_field_activity_type = /** @type {(inputs: Field_Activity_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitas`)
};

const it_field_activity_type = /** @type {(inputs: Field_Activity_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attività`)
};

const ru_field_activity_type = /** @type {(inputs: Field_Activity_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип активности`)
};

const pt_field_activity_type = /** @type {(inputs: Field_Activity_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade`)
};

const ko_field_activity_type = /** @type {(inputs: Field_Activity_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`활동 종류`)
};

/**
* | output |
* | --- |
* | "Activity" |
*
* @param {Field_Activity_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_activity_type = /** @type {((inputs?: Field_Activity_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Activity_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_activity_type(inputs)
	if (locale === "es") return es_field_activity_type(inputs)
	if (locale === "fr") return fr_field_activity_type(inputs)
	if (locale === "de") return de_field_activity_type(inputs)
	if (locale === "ja") return ja_field_activity_type(inputs)
	if (locale === "zh") return zh_field_activity_type(inputs)
	if (locale === "ar") return ar_field_activity_type(inputs)
	if (locale === "id") return id_field_activity_type(inputs)
	if (locale === "it") return it_field_activity_type(inputs)
	if (locale === "ru") return ru_field_activity_type(inputs)
	if (locale === "pt") return pt_field_activity_type(inputs)
	return ko_field_activity_type(inputs)
});